import React, { useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";

function DropdownSingleChoice({
  labelText,
  translationValue,
  id,
  name,
  values,
  defaultValue,
  selectedValue,
  onChange,
  disabled,
  hideNone,
}) {
  const { t } = useTranslation();
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    //className={`dropdownSingleChoiceComponent ${orientation == 'row' ? 'dropdownSingleChoiceComponent-orientation-row' : 'dropdownSingleChoiceComponent-orientation-column'}`}
    <FormControl fullWidth>
      <InputLabel
        id="select-label"
        htmlFor={id ?? name}
        sx={{ color: "#373437" }}
      >
        {labelText}
      </InputLabel>
      <Select
        disabled={disabled}
        disablePortal
        MenuProps={{ disableScrollLock: true }}
        fullWidth
        labelId="select-label"
        id={id ?? name}
        name={name}
        label={labelText}
        onChange={handleChange}
        defaultValue={defaultValue}
      >
        {hideNone ? null : (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        )}
        {values?.map((value, index) => {
          let translationPath = translationValue + value;

          if (value === selectedValue) {
            return (
              <MenuItem selected key={index} value={value}>
                {t(translationPath)}
              </MenuItem>
            );
          } else {
            return (
              <MenuItem key={index} value={value}>
                {t(translationPath)}
              </MenuItem>
            );
          }
        })}
      </Select>
      {/*<label htmlFor={id ?? name}>{labelText}</label>
            <select name={name} id={id ?? name} onChange={handleChange}>
                {defaultText ? <option value='' selected disabled hidden>{defaultText}</option> : <></>}
                {
                    values?.map((value, index) => {
                        if (value == selectedValue) {
                            return (<option selected key={index} value={value}>{value}</option>);
                        }
                        else {
                            return (<option key={index} value={value}>{value}</option>);
                        }                        
                    })
                }
            </select>
            <div className='pom'></div>*/}
    </FormControl>
  );
}

export default DropdownSingleChoice;
